import { render } from "./DocumentsDownloadModal.vue?vue&type=template&id=77c33ace&scoped=true"
import script from "./DocumentsDownloadModal.vue?vue&type=script&lang=js"
export * from "./DocumentsDownloadModal.vue?vue&type=script&lang=js"

import "./DocumentsDownloadModal.vue?vue&type=style&index=0&id=77c33ace&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c33ace"]])

export default __exports__